export default __webpack_public_path__ + "static/media/mascot.247b2ed2.png";